// openEHR RM model — barrel for rm.common
// Generated by tasks/split_model_by_bmm_packages.ts from tasks/bmm_package_map.json.
// Package boundaries follow the BMM package structure; edit the class bodies here,
// but re-run the splitter rather than hand-moving declarations between packages.

export * from "./generic.ts";
export * from "./archetyped.ts";
export * from "./change_control.ts";
export * from "./directory.ts";
export * from "./resource.ts";
export * from "./tags.ts";
